module.exports = __webpack_public_path__ + "static/media/16_potolok_2.71_0.c1723b3b.png";